import { useEffect, useState } from 'react'
import api from '@/services/api'

export type DealCloserOption = { id: string; name: string }

export function useDealsTeamClosers(enabled: boolean) {
  const [closers, setClosers] = useState<DealCloserOption[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!enabled) {
      setClosers([])
      return
    }

    let cancelled = false
    setLoading(true)

    api
      .get('/users', {
        params: { role: 'closer', limit: 100, sortBy: 'name', sortOrder: 'asc' },
      })
      .then((resp) => {
        if (cancelled) return
        const raw = resp.data.data ?? resp.data ?? []
        const items = (Array.isArray(raw) ? raw : [])
          .map((user: { id: string; name: string }) => ({
            id: user.id,
            name: user.name,
          }))
          .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'))
        setClosers(items)
      })
      .catch(() => {
        if (!cancelled) setClosers([])
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [enabled])

  return { closers, loading }
}
